import { render, staticRenderFns } from "./AutomationsMenu.vue?vue&type=template&id=bdb05492&scoped=true&"
import script from "./AutomationsMenu.vue?vue&type=script&lang=js&"
export * from "./AutomationsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AutomationsMenu.vue?vue&type=style&index=0&id=bdb05492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb05492",
  null
  
)

export default component.exports